import { render, staticRenderFns } from "./DirectPlacement.vue?vue&type=template&id=013f3adb&scoped=true"
import script from "./DirectPlacement.vue?vue&type=script&lang=js"
export * from "./DirectPlacement.vue?vue&type=script&lang=js"
import style0 from "./DirectPlacement.vue?vue&type=style&index=0&id=013f3adb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013f3adb",
  null
  
)

export default component.exports